/**
 * Which of the app's engines this environment actually has.
 *
 * Redact ships a table of Speechmatics engine ids per language
 * (`utils/speechmatics/engines.ts`). The ids are a fact about Speechmatics and
 * the same everywhere, but whether a given engine is DEPLOYED is a fact about
 * the environment — aiWARE instances are provisioned separately, and the Azure
 * and gov clusters do not necessarily carry every language the public cloud
 * does. Offering a language whose engine is not there produces a job that
 * fails after the user has waited for it.
 *
 * So the table says what we know how to run and this says what can be run
 * here, and the language dropdown is the intersection.
 */
export const namespace = 'vtn-redact-engine-availability';

export interface EngineAvailabilityStore {
  /**
   * Engine ids confirmed present and active here.
   *
   * `null` means "not answered yet", which is NOT the same as "none" and is
   * why this is not an empty array. Callers treat null as "assume everything
   * works": a dropdown that renders empty while a query is in flight would
   * take transcription away from every user for the first seconds of every
   * session, and on a failed query would take it away for good. Narrowing the
   * list is an improvement on the optimistic answer, never a precondition for
   * showing one.
   */
  availableIds: readonly string[] | null;
}

export const defaultState: EngineAvailabilityStore = {
  availableIds: null,
};
